<template>

  <div style="background-color:#5f5e5e;">
    <div style="width: 1200px;text-align: center;margin: auto;display: block;padding-bottom: 15px;">
      <ul style="list-style: none;height: 50px;position: relative;display: block;padding-top: 10px;margin: 0;padding-left: 0;">
        <li style="font-size: 18px;color: white;float: left;margin-top: 10px;font-weight: bolder;margin-right: 20px;">为什么选择官网？</li>
        <li style="color: white;float: left;width: 220px;text-align: left;line-height: 18px;margin-left: 25px;">
          <img src="/static/images/pic1.png" style="float: left;">
          <a style="font-size: 18px;display: block;margin-top: 8px;position: relative;left: 10px;">产品齐全</a>
          <a style="font-size: 13px;position: relative;left: 10px;">产品自主选，随心买</a>
        </li>
        <li style="color: white;float: left;width: 220px;text-align: left;line-height: 18px;margin-left: 25px;">
          <img src="/static/images/pic2.png" style="float: left;">
          <a style="font-size: 18px;display: block;margin-top: 8px;position: relative;left: 10px;">便利快捷</a>
          <a style="font-size: 13px;position: relative;left: 10px;">7*24小时不打烊，随时买</a>
        </li>
        <li style="color: white;float: left;width: 220px;text-align: left;line-height: 18px;margin-left: 25px;">
          <img src="/static/images/pic3.png" style="float: left;">
          <a style="font-size: 18px;display: block;margin-top: 8px;position: relative;left: 10px;">安全支付</a>
          <a style="font-size: 13px;position: relative;left: 10px;">知名支付工具，放心买</a>
        </li>
        <li style="color: white;float: left;width: 220px;text-align: left;line-height: 18px;margin-left: 25px;">
          <img src="/static/images/pic1.png" style="float: left;">
          <a style="font-size: 18px;display: block;margin-top: 8px;position: relative;left: 10px;">贴心服务</a>
          <a style="font-size: 13px;position: relative;left: 10px;">客服全年无休，安心买</a>
        </li>
      </ul>
    </div>
    <div style="display: block;width: 1200px;margin: auto;text-align: center;height: 190px;padding-top: 15px;color: #BEBEBE;border-top: 1px solid #6C6C6C;">
<!--      <ul style="width: 200px;list-style: none;padding: 0;margin: 0;float: left;text-align: left;">-->
<!--        <li style="font-size: 17px;margin-bottom: 10px;">帮助中心</li>-->
<!--        <li style="font-size: 14px; cursor: pointer;" @click="window.open('/News/Get.html?id=23851')">签证护照</li>-->
<!--        <li style="font-size: 14px;cursor: pointer;" @click="window.open('/News/Get.html?id=23831')">签证问题</li>-->
<!--      </ul>-->
      <ul style="width: 200px;list-style: none;padding: 0;margin: 0;float: left;text-align: left;">
        <li style="font-size: 18px;margin-bottom: 10px;">关于我们</li>
        <li style="font-size: 16px;cursor: pointer;" @click="utils.NavigationPage({path:'/Template/About/'})">走进口岸</li>
        <li style="font-size: 16px;cursor: pointer;" @click="utils.NavigationPage({path:'https://m.fspits.com/Template/Navigation.html'})">门店导航</li>
        <li style="font-size: 16px;cursor: pointer;" @click="utils.NavigationPage({path:'/Template/culture/'})">文明旅游</li>
      </ul>
      <ul style="width: 400px;list-style: none;padding: 0;margin: 0;float: left;text-align: left;">
        <li style="font-size: 18px;margin-bottom: 10px;">联系我们</li>
        <!-- <li style="font-size: 14px;">客服热线：(0757)0757—22620123/29288811</li> -->
        <!-- <li style="font-size: 14px;"> 24 小时质量监督投诉电话:0757-29963162、13106743920 (微信同号)
邮箱：oa@fspits.com</li> -->
        <li style="font-size: 16px;">总部客服热线:0757-29963030</li>
        
        <li style="font-size: 16px;">客服热线:0757-22620123</li>
        <li style="font-size: 16px;">客服热线:0757-29288811</li>
        <li style="font-size: 16px;">24小时质量监督投诉电话:0757-29963162</li>
        <li style="font-size: 16px;">24小时质量监督投诉电话:18025981056 (微信同号)</li>
        <li style="font-size: 16px;">邮箱：oa@fspits.com</li>

      </ul>

      <ul style="width: 200px;list-style: none;padding: 0;margin: 0;float: left;text-align: left;">
        <!-- <li style="font-size: 17px;margin-bottom: 10px;">关注我们：</li> -->
        <!-- <li style="font-size: 14px;float: left;margin-right: 10px;"><img style="width: 115px;height: 115px;" src="//filewww.fspits.com/File/2018/0226/20180226165208-7IGOO9tYw3BHLRfco3Ej404fWmxVU4Y1.jpg"></li> -->
        <li style="font-size: 14px;"><img style="width: 180px;height: 180px;" src="/static/images/logo6.jpg"></li>
        <!-- <li style="float: left;margin-right: 10px;width: 115px;font-size: 11px;">关注团队动态信息</li> -->
        <!-- <li style="font-size: 11px;">接收最新优惠</li> -->
      </ul>
      <ul style="width: 200px;list-style: none;padding: 0;margin: 0;float: left;text-align: left;">
        <li style="font-size: 14px;"><img style="width: 180px;height: 180px;" src="/static/images/logo9.png"></li>

      </ul>
      <ul style="width: 200px;list-style: none;padding: 0;margin: 0;float: left;text-align: left;">
        <li style="font-size: 14px;"><img style="width: 180px;height: 200px;" src="/static/images/logo8.jpg"></li>

      </ul>
    </div>

    <div style="padding:10px 0; text-align: center;font-size: 13px;width: 1200px;margin: auto;border-top: 1px solid #6C6C6C;">

      <!--<a class="FootLinkClass">友情链接</a>
      <a class="FootLinkClass" @click="window.open('http://cn.tourismthailand.org/')">泰国旅游局</a>
      <a style="border-right: 5px;border-left: 5px;cursor: default;color:#BEBEBE;">|</a>
      <a class="FootLinkClass" @click="window.open('http://www.newzealand.com/cn/')">新西兰旅游局</a>
      <a style="border-right: 5px;border-left: 5px;cursor: default;color:#BEBEBE;">|</a>
      <a class="FootLinkClass" @click="window.open('http://www.australia.cn/')">澳大利亚旅游局</a>
      <a style="border-right: 5px;border-left: 5px;cursor: default;color:#BEBEBE;">|</a>
      <a class="FootLinkClass" @click="window.open('http://www.discoverhongkong.com/china/index.jsp')">香港旅游发展局</a>
      <a style="border-right: 5px;border-left: 5px;cursor: default;color:#BEBEBE;">|</a>
      <a class="FootLinkClass" @click="window.open('http://www.welcome2japan.cn/')">日本旅游局</a>
      <a style="border-right: 5px;border-left: 5px;cursor: default;color:#BEBEBE;">|</a>
      <a class="FootLinkClass" @click="window.open('http://console.www.fspits.cn')">网站后台管理</a>
      <a style="border-right: 5px;border-left: 5px;cursor: default;color:#BEBEBE;">|</a>
      <a class="FootLinkClass" @click="window.open('http://erp.fspits.com')">口岸员工通道</a>-->


      <a></a>
      <br>
      <a class="FootLinkClass">2021 佛山市口岸国际旅行社有限公司</a>
      <a style="border-right: 5px;border-left: 5px;cursor: default;color:#BEBEBE;">|</a>
      <a class="FootLinkClass">总部地址：佛山市顺德区大良德胜中路万科天傲湾二期9号楼3楼</a>
      <br>
      <a class="FootLinkClass">旅行社业务经营许可证号： L-GD-CJ00089</a>
      <a style="border-right: 5px;border-left: 5px;cursor: default;color:#BEBEBE;">|</a>
      <a class="FootLinkClass">ICP经营许可号：粤ICP备16020362号</a>
      <br>
      <a class="FootLinkClass">技术支持：口岸国旅-在线部</a>
    </div>
  </div>

</template>

<script>
  export default {
    name: "AppFoot"
  }
</script>

<style scoped>
  .FootLinkClass {
    cursor: pointer;
    color:#BEBEBE;
  }

  .FootLinkClass:hover {
    text-decoration:none;
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/AppFoot.vue